import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm, FormsModule } from '@angular/forms';



@Component({
  selector: 'app-siteuseredit',
  templateUrl: './siteuseredit.component.html',
  styleUrls: ['./siteuseredit.component.css']
})
export class SiteusereditComponent implements OnInit {

  idno: string;
  userData: any;
  user: User;
  data: any;
  RoleDataAny: any;

  constructor(private router: Router, private route: ActivatedRoute,
    private userServices: UserService) {
    this.idno = this.route.snapshot.params.userid;
  }

  ngOnInit() {
    debugger;
    this.userServices.EditSiteUser(this.idno).subscribe(
      (data) => {
        this.userData = data;
        this.user = this.userData;
        console.log(this.userData);
      }
    )

    this.getRoleValue();
  }

  getRoleValue() {
    this.userServices.getRoleValue().subscribe(
      (data) => {
        this.RoleDataAny = data;
        this.data = this.RoleDataAny;
        console.log("user data" + this.data);
      }
    )
  }

  editSiteUserForm(form: NgForm) {
    debugger;
    form.value.id = this.idno;
    // if (form.value.userType) {
    //   if (form.value.userType == "1") {
    //     form.value.registerCode = "royaladmin";
    //     form.value.type = "Admin";
    //   }
    //   else if (form.value.userType == "2") {
    //     form.value.registerCode = "dpvpvendor";
    //     form.value.type = "Vendor";
    //   }
    //   else if (form.value.userType == "3") {
    //     form.value.registerCode = "dpvppurchase";
    //     form.value.type = "Purchase";
    //   }
    //   else if (form.value.userType == "4") {
    //     form.value.registerCode = "dpvpfinance";
    //     form.value.type = "Finance";
    //   }
    //   else if (form.value.userType == "5") {
    //     form.value.registerCode = "dpvpsiteinc";
    //     form.value.type = "SiteIncharge";
    //   }
    //   else if (form.value.userType == "6") {
    //     form.value.registerCode = "dpvptransport";
    //     form.value.type = "TransportManager";
    //   }
    //   else { }
    // }
    console.log(form.value);
    this.userServices.submitSiteUserForm(form.value).subscribe(
      (data: any) => {
        if (data == true) {
          alert("successfully updated");
        }
        else {
          alert("An error occured");
        }
      }
    )
  }

  sendCeredentials()
  {
    this.userServices.SendUserCredentials(this.idno).subscribe(
      (data : any) => {
        if(data == true)
        {
          alert("Login Ceredentials Sent");
        }
        else{
          alert("An error occured");
        }
      }
    )
  }

}
